namespace GeniuzPOS.Inventory {
    export interface IcStockReturnOutRow {
        Id?: number;
        SysDocNo?: string;
        DocNo?: string;
        DocDate?: string;
        RefDocNo1?: string;
        RefDocNo2?: string;
        StockTo?: string;
        SupplName?: string;
        WhsId?: string;
        WhsName?: string;
        Remark?: string;
        PostFg?: PostFgStatus;
        CreateBy?: string;
        CreateDate?: string;
        UpdateBy?: string;
        LastUpdate?: string;
        ReturnOutDtList?: IcStockReturnOutDtRow[];
        CancelFg?: CancelFgstatus;
        CheckQty?: number;
    }

    export namespace IcStockReturnOutRow {
        export const idProperty = 'SysDocNo';
        export const nameProperty = 'DocNo';
        export const localTextPrefix = 'Inventory.IcStockReturnOut';
        export const lookupKey = 'Inventory.IcStockReturnOut';

        export function getLookup(): Q.Lookup<IcStockReturnOutRow> {
            return Q.getLookup<IcStockReturnOutRow>('Inventory.IcStockReturnOut');
        }
        export const deletePermission = '2Inventory:รายการ:ส่งคืน:Modify';
        export const insertPermission = '2Inventory:รายการ:ส่งคืน:Modify';
        export const readPermission = '2Inventory:รายการ:ส่งคืน:View';
        export const updatePermission = '2Inventory:รายการ:ส่งคืน:Modify';

        export declare const enum Fields {
            Id = "Id",
            SysDocNo = "SysDocNo",
            DocNo = "DocNo",
            DocDate = "DocDate",
            RefDocNo1 = "RefDocNo1",
            RefDocNo2 = "RefDocNo2",
            StockTo = "StockTo",
            SupplName = "SupplName",
            WhsId = "WhsId",
            WhsName = "WhsName",
            Remark = "Remark",
            PostFg = "PostFg",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            UpdateBy = "UpdateBy",
            LastUpdate = "LastUpdate",
            ReturnOutDtList = "ReturnOutDtList",
            CancelFg = "CancelFg",
            CheckQty = "CheckQty"
        }
    }
}
